import { Controller } from "@hotwired/stimulus"

// A collapsible list section whose open/closed state is remembered per key in localStorage — the
// Kundengruppen of the grouped Kunden list. A slimmed planning_section_controller.js without the
// board-wide expand/collapse registry.
//
// The content target is typically a lazy turbo-frame: while it is hidden it stays unloaded, so a
// collapsed section costs no request.
export default class extends Controller {
  static targets = ["content", "icon", "toggle"]
  static values = { key: String, defaultCollapsed: Boolean }

  static STORAGE_KEY = "collapsible_section_states"

  connect() {
    this.expanded = this.loadState()
    this.applyState()
  }

  toggle() {
    this.expanded = !this.expanded
    this.saveState()
    this.applyState()
  }

  applyState() {
    if (this.hasContentTarget) this.contentTarget.classList.toggle("hidden", !this.expanded)
    if (this.hasIconTarget) this.iconTarget.classList.toggle("-rotate-90", !this.expanded)
    if (this.hasToggleTarget) this.toggleTarget.setAttribute("aria-expanded", String(this.expanded))
  }

  loadState() {
    const stored = this.readStates()[this.keyValue]
    return typeof stored === "boolean" ? stored : !this.defaultCollapsedValue
  }

  saveState() {
    const states = this.readStates()
    states[this.keyValue] = this.expanded
    try {
      localStorage.setItem(this.constructor.STORAGE_KEY, JSON.stringify(states))
    } catch (_e) {
      // Private mode or a full store: the section still toggles, it just is not remembered.
    }
  }

  readStates() {
    try {
      return JSON.parse(localStorage.getItem(this.constructor.STORAGE_KEY) || "{}") || {}
    } catch (_e) {
      return {}
    }
  }
}
